<div class="p-2 md:p-4">
  <div class="flex align-items-center justify-content-between mb-4">
    <h2 class="text-2xl font-semibold m-0" data-clarity-unmask="true">Dodaj nowy slajd</h2>
    <p-button
    [text]="true"
    [rounded]="true"
      icon="pi pi-times"
      (onClick)="cancel()"
      data-clarity-unmask="true"
    ></p-button>
  </div>

  <div class="flex align-items-center justify-content-center mb-4">
    <div class="flex align-items-center">
      <div class="flex align-items-center">
        <div
          class="flex align-items-center justify-content-center border-circle"
          [ngClass]="{
            'bg-primary text-white': currentStep >= 1,
            'border-primary text-primary': currentStep < 1
          }"
          style="width: 32px; height: 32px; border: 2px solid"
        >
          <span class="font-semibold">1</span>
        </div>
        <span
          class="ml-2 font-medium"
          [ngClass]="{ 'text-primary': currentStep >= 1 }"
          >Dane podstawowe</span
        >
      </div>

      <div
        class="mx-3 step-line"
        style="width: 60px; height: 2px; background-color: #e2e8f0"
        [ngClass]="{ 'bg-primary': currentStep >= 2 }"
      ></div>

      <div class="flex align-items-center">
        <div
          class="flex align-items-center justify-content-center border-circle"
          [ngClass]="{
            'bg-primary text-white': currentStep >= 2,
            'border-primary text-primary': currentStep < 2
          }"
          style="width: 32px; height: 32px; border: 2px solid"
        >
          <span class="font-semibold">2</span>
        </div>
        <span
          class="ml-2 font-medium"
          [ngClass]="{ 'text-primary': currentStep >= 2 }"
          >Multimedia</span
        >
      </div>
    </div>
  </div>

  <div
    *ngIf="loading"
    class="flex justify-content-center align-items-center p-4"
  >
    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
  </div>

  <div *ngIf="currentStep === 1 && !loading">
    <form [formGroup]="contentForm">
      <div
        class="form-decorator top-decorator flex w-full justify-content-left align-items-center mt-4"
      >
        <div class="title">Przypisany dział wykładu</div>
        <p-dropdown
          id="categorySelect"
          formControlName="categoryId"
          [options]="elearningTopicCategories"
          optionLabel="name"
          optionValue="id"
          placeholder="Wybierz dział"
          appendTo="body"
          class="w-full"
          (onChange)="onCategoryChange($event.value)"
          [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('categoryId') }"
        >
        </p-dropdown>
      </div>

      <div
        class="form-decorator flex w-full justify-content-left align-items-center"
      >
        <div class="title">Przypisany rozdział wykładu</div>
        <p-dropdown
          id="topicSelect"
          formControlName="elearningTopicId"
          [options]="availableTopics"
          optionLabel="name"
          optionValue="id"
          placeholder="Wybierz rozdział"
          appendTo="body"
          class="w-full"
          [disabled]="availableTopics.length === 0"
          [ngClass]="{
            'ng-invalid ng-dirty': isFieldInvalid('elearningTopicId')
          }"
          (onChange)="onTopicChange($event.value)"
        >
        </p-dropdown>
      </div>

      <div
        class="form-decorator flex w-full justify-content-left align-items-center"
      >
        <div class="title">Kategorie egzaminów (opcjonalnie)</div>
        <p-multiSelect
          [appendTo]="'body'"
          id="examsGuid"
          formControlName="examsGuid"
          [options]="availableExamsForSelectedCategory"
          optionLabel="examName"
          optionValue="guid"
          placeholder="Widoczny dla wszystkich kategorii działu"
          styleClass="custom-multiselect w-full"
          class="w-full"
          [disabled]="availableExamsForSelectedCategory.length === 0"
          [showToggleAll]="false"
          [filter]="false"
          [maxSelectedLabels]="10"
        >
        </p-multiSelect>
      </div>

      <div
        class="form-decorator flex w-full justify-content-left align-items-center"
      >
        <div class="title">Tytuł slajdu</div>
        <input
          id="slideTitle"
          type="text"
          pInputText
          formControlName="slideTitle"
          placeholder="Tytuł slajdu"
          [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('slideTitle') }"
        />
      </div>

      <div
        class="form-decorator flex w-full justify-content-left align-items-center"
      >
        <div class="title">Treść slajdu</div>
        <textarea
          id="slideContent"
          formControlName="slideContent"
          rows="10"
          placeholder="Wprowadź wyjaśnienie po polsku..."
          class="default-input"
        ></textarea>
      </div>

      <div
        class="form-decorator flex w-full justify-content-left align-items-center mb-6"
      >
        <div class="title">Pozycja slajdu</div>
        <p-inputNumber
          id="slideOrder"
          formControlName="slideOrder"
          placeholder="Pozycja"
          class="w-full"
          styleClass="w-full"
          [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('slideOrder') }"
        >
        </p-inputNumber>
      </div>

      <div formArrayName="translations">
        <div
          *ngFor="
            let translationForm of translationsArray.controls;
            let i = index
          "
          [formGroupName]="i"
        >
          <div
            class="form-decorator cursor-pointer flex w-full justify-content-between align-items-center"
            (click)="toggleTranslationCollapse(i)"
          >
            <div class="flex gap-2 align-items-center">
              <i class="pi pi-flag"></i>
              <div class="font-medium">
                Wersja językowa {{ i + 1 }}
                <span *ngIf="translationForm.get('languageCode')?.value">
                  -
                  {{
                    getLanguageName(translationForm.get("languageCode")?.value)
                  }}</span
                >
              </div>
            </div>
            <i
              class="pi"
              [ngClass]="
                isTranslationCollapsed(i) ? 'pi-chevron-down' : 'pi-chevron-up'
              "
            ></i>
          </div>

          <div *ngIf="!isTranslationCollapsed(i)">
            <div
              class="form-decorator off-bottom-border flex w-full justify-content-left align-items-center"
            >
              <div class="title">Wybierz język</div>
              <p-dropdown
                [options]="getAvailableLanguagesForTranslation(i)"
                optionLabel="name"
                optionValue="code"
                placeholder="Wybierz język"
                class="w-full"
                styleClass="w-full"
                formControlName="languageCode"
              >
              </p-dropdown>
            </div>
            <div
              class="form-decorator off-bottom-border flex w-full justify-content-left align-items-center"
            >
              <div class="title">Tytuł slajdu</div>
              <input
                type="text"
                pInputText
                formControlName="slideTitle"
                placeholder="Tytuł slajdu"
              />
            </div>
            <div
              class="form-decorator off-bottom-border flex w-full justify-content-left align-items-center"
            >
              <div class="title">Treść slajdu</div>
              <textarea
                pInputTextarea
                formControlName="slideContent"
                placeholder="Treść slajdu"
                rows="4"
              >
              </textarea>
            </div>
            <div class="flex w-full justify-content-end form-decorator bottom-primary-decorator">
              <p-button
                label="Usuń tą wersję językową"
                icon="pi pi-trash"
                (onClick)="removeTranslationForm(i); $event.stopPropagation()"
                data-clarity-unmask="true"
              >
              </p-button>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="canAddMoreTranslations()"
        class="form-decorator cursor-pointer flex w-full justify-content-between align-items-center mb-3"
        (click)="addNewTranslationForm()"
      >
        <div class="add-translation">Dodaj kolejną wersję językową</div>
        <i class="add-translation pi pi-plus"></i>
      </div>
    </form>

    <div class="flex gap-3 justify-content-end pt-3">
      <p-button [link]="true" label="Anuluj" (onClick)="cancel()" data-clarity-unmask="true"></p-button>
      <p-button
        label="Dalej"
        icon="pi pi-angle-right"
        iconPos="right"
        (onClick)="nextStep()"
        [disabled]="!canProceedToNextStep()"
        data-clarity-unmask="true"
      ></p-button>
    </div>
  </div>

  <div *ngIf="currentStep === 2 && !loading">
    <div class="mb-4">
      <div
        class="form-decorator bottom-primary-decorator flex-column top-decorator flex w-full justify-content-start align-items-start gap-4 mt-4"
      >
        <div class="title">Standardowa wersja PL</div>
        <div class="flex flex-column md:flex-row w-full gap-2">
          <div class="w-full">
            <fas-services-upload
              [environment]="environment.webApiUrl"
              [allowedExtensions]="['.png', '.jpg', '.jpeg', 'webp']"
              [mainIcon]="'pi-image'"
              [multiple]="false"
              mainMessage="Wybierz plik graficzny z dysku lub przeciągnij tu."
              (fileSelected)="onImageSelected($event, 'pl')"
              class="w-full"
            >
            </fas-services-upload>
          </div>
          <div class="w-full">
            <fas-services-upload
              [environment]="environment.webApiUrl"
              [allowedExtensions]="['.mp4', '.avi', '.mov', '.wmv']"
              [mainIcon]="'pi-video'"
              [multiple]="false"
              mainMessage="Wybierz plik wideo z dysku lub przeciągnij tu."
              (fileSelected)="onVideoSelected($event, 'pl')"
              class="w-full"
            >
            </fas-services-upload>
          </div>
          <div class="w-full">
            <fas-services-upload
              [environment]="environment.webApiUrl"
              [allowedExtensions]="['.mp3', '.wav', '.ogg', '.m4a']"
              [mainIcon]="'pi-volume-up'"
              [multiple]="false"
              mainMessage="Wybierz plik audio z dysku lub przeciągnij tu."
              (fileSelected)="onAudioSelected($event, 'pl')"
              class="w-full"
            >
            </fas-services-upload>
          </div>
        </div>
      </div>

      <div>
        <div
          *ngFor="
            let languageCode of getSelectedMediaLanguages();
            let i = index
          "
        >
          <div
            class="form-decorator off-bottom-border cursor-pointer flex w-full justify-content-between align-items-center"
            (click)="toggleMediaLanguageCollapse(languageCode)"
          >
            <div class="flex gap-2 align-items-center">
              <i class="pi pi-flag"></i>
              <div class="font-medium">
                Media dla języka: {{ getLanguageName(languageCode) }}
              </div>
            </div>
            <i
              class="pi"
              [ngClass]="
                isMediaLanguageCollapsed(languageCode)
                  ? 'pi-chevron-down'
                  : 'pi-chevron-up'
              "
            ></i>
          </div>

          <div *ngIf="!isMediaLanguageCollapsed(languageCode)">
            <div
              class="form-decorator off-bottom-border flex w-full justify-content-left align-items-center gap-3"
            >
              <div class="w-full">
                <fas-services-upload
                  [environment]="environment.webApiUrl"
                  [allowedExtensions]="['.png', '.jpg', '.jpeg', 'webp']"
                  [mainIcon]="'pi-image'"
                  [multiple]="false"
                  mainMessage="Wybierz plik graficzny z dysku lub przeciągnij tu."
                  (fileSelected)="onImageSelected($event, languageCode)"
                  class="w-full"
                >
                </fas-services-upload>
              </div>
              <div class="w-full">
                <fas-services-upload
                  [environment]="environment.webApiUrl"
                  [allowedExtensions]="['.mp4', '.avi', '.mov', '.wmv']"
                  [mainIcon]="'pi-video'"
                  [multiple]="false"
                  mainMessage="Wybierz plik wideo z dysku lub przeciągnij tu."
                  (fileSelected)="onVideoSelected($event, languageCode)"
                  class="w-full"
                >
                </fas-services-upload>
              </div>
              <div class="w-full">
                <fas-services-upload
                  [environment]="environment.webApiUrl"
                  [allowedExtensions]="['.mp3', '.wav', '.ogg', '.m4a']"
                  [mainIcon]="'pi-volume-up'"
                  [multiple]="false"
                  mainMessage="Wybierz plik audio z dysku lub przeciągnij tu."
                  (fileSelected)="onAudioSelected($event, languageCode)"
                  class="w-full"
                >
                </fas-services-upload>
              </div>
            </div>

            <div class="flex w-full justify-content-end form-decorator bottom-primary-decorator">
              <p-button
                label="Usuń media dla tego języka"
                icon="pi pi-trash"
                (onClick)="
                  removeMediaLanguage(languageCode); $event.stopPropagation()
                "
                data-clarity-unmask="true"
              >
              </p-button>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="canAddMoreMediaLanguages()"
        class="form-decorator cursor-pointer flex w-full justify-content-between align-items-center mb-3"
        (click)="showAddMediaLanguageDropdown = !showAddMediaLanguageDropdown"
      >
        <div class="add-translation">Dodaj media dla kolejnego języka</div>
        <i class="add-translation pi pi-plus"></i>
      </div>

      <div
        *ngIf="showAddMediaLanguageDropdown && canAddMoreMediaLanguages()"
        class="form-decorator flex w-full justify-content-left align-items-center mb-3"
      >
        <div class="title">Wybierz język</div>
        <p-dropdown
          [appendTo]="'body'"
          [options]="getAvailableLanguagesForMedia()"
          optionLabel="name"
          optionValue="code"
          placeholder="Wybierz język dla mediów"
          class="w-full"
          styleClass="w-full"
          [(ngModel)]="selectedNewMediaLanguage"
          (onChange)="onNewMediaLanguageSelected()"
        >
        </p-dropdown>
      </div>
    </div>

    <div class="flex justify-content-between pt-3">
      <p-button
        [link]="true"
        label="Poprzedni"
        icon="pi pi-angle-left"
        (onClick)="previousStep()"
        data-clarity-unmask="true"
      ></p-button>
      <div class="flex gap-2">
        <p-button [link]="true" label="Anuluj" (onClick)="cancel()" data-clarity-unmask="true"></p-button>
        <p-button
          label="Zapisz"
          icon="pi pi-save"
          [disabled]="!contentForm.valid || loading"
          (onClick)="save()"
          data-clarity-unmask="true"
        ></p-button>
      </div>
    </div>
  </div>
</div>
